import React, { PropsWithChildren, RefObject } from 'react'
import { useTranslation } from 'react-i18next'

import { useModal } from '@context/ModalsContext'

import { IconButton } from '@ui/components/Button'
import { Tooltip } from '@ui/components/Tooltip/Tooltip'
import { ArrowIcon } from '@ui/icons/Arrow.icon'
import { CloseIcon } from '@ui/icons/Close.icon'

import { useWindowResize } from '@utils/domUtils'

import { useFundingExit } from '@hooks/useFundingExit'

import { ActionModal } from '@shared/modals/Action.modal'
import { FullScreenLayout } from '@shared/templates/FullScreenLayout'

interface DepositTemplateProps extends PropsWithChildren {
  onBack?: () => void
  onExit?: () => void
  maxWidth?: number
  isLoading?: boolean
  contentRef?: RefObject<HTMLDivElement | null>
  header?: React.ReactNode
}

export const FundingTemplate: React.FC<DepositTemplateProps> = (props) => {
  const { isLoading, onBack, onExit, children, maxWidth, contentRef, header } = props

  const { t } = useTranslation()
  const isMobile = useWindowResize()
  const { handleExit } = useFundingExit()

  const cancelModal = useModal(ActionModal, {
    onConfirm: handleExit,
  })

  return (
    <FullScreenLayout
      maxContentWidth={maxWidth}
      contentRef={contentRef}
      isLoading={isLoading}
      header={header}
      headerLeftSlot={
        onBack ? (
          <Tooltip
            content={t('Trading Account.Go Back')}
            direction='top'
            pointer
            disabled={isMobile}
          >
            <IconButton.Secondary size='sm' icon={ArrowIcon.Left} onClick={onBack} />
          </Tooltip>
        ) : undefined
      }
      headerRightSlot={
        <Tooltip content={t('Exit')} direction='top' pointer disabled={isMobile}>
          <IconButton.Secondary
            size='sm'
            icon={CloseIcon}
            onClick={() => {
              if (onExit) return onExit()
              if (cancelModal.isOpen) return
              cancelModal.open()
            }}
          />
        </Tooltip>
      }
    >
      {children}
    </FullScreenLayout>
  )
}
